module.exports = __webpack_public_path__ + "img/space-introduce-1.22e71b4b.svg";